import { a as userAgentIsRobot, i as isValidBrowserOnline, n as isBrowserOnline, r as isValidBrowser, t as inBrowser } from "./browser-CMFCxUv7.mjs";

export { inBrowser, isBrowserOnline, isValidBrowser, isValidBrowserOnline, userAgentIsRobot };